module.exports = __webpack_public_path__ + "static/media/facebook.b9f35261.svg";